module.exports = __webpack_public_path__ + "static/img/inviteBoxBg.8ecd1f8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/cashWheel/inviteBoxBg.png
// module id = 0tOZ
// module chunks = 0